import SettingsChat from "./SettingsChat";

export default SettingsChat;